import { z } from 'zod';

export const GlobalSearchResultSourceSchema = z.enum(['navigation', 'entity']);

export const GlobalSearchResultTypeSchema = z.enum([
  'navigation',
  'project',
  'release',
  'feature',
  'executionRun',
  'resultsFile',
  'suite',
  'test',
  'pipeline',
  'job',
  'stage',
  'coverageRun',
  'coverageDirectory',
  'coverageFile',
]);

export const GlobalSearchResultContextSchema = z
  .object({
    organisationId: z.string().nullable(),
    projectId: z.string().nullable(),
  })
  .strict();

export const GlobalSearchResultSchema = z
  .object({
    id: z.string(),
    source: GlobalSearchResultSourceSchema,
    type: GlobalSearchResultTypeSchema,
    title: z.string(),
    subtitle: z.string().nullable(),
    href: z.string(),
    context: GlobalSearchResultContextSchema,
  })
  .strict();

export const GlobalSearchQuerySchema = z
  .object({
    query: z.string().trim().min(1).max(120),
    organisationId: z.string().nullable().optional(),
    projectId: z.string().nullable().optional(),
    limit: z.number().int().positive().max(40).optional(),
  })
  .strict();

export const GlobalSearchResultSchemaArray = z.array(GlobalSearchResultSchema);

export const GlobalSearchResponseSchema = z
  .object({
    results: GlobalSearchResultSchemaArray,
  })
  .strict();

export type GlobalSearchResultSource = z.infer<typeof GlobalSearchResultSourceSchema>;
export type GlobalSearchResultType = z.infer<typeof GlobalSearchResultTypeSchema>;
export type GlobalSearchResultContext = z.infer<typeof GlobalSearchResultContextSchema>;
export type GlobalSearchResult = z.infer<typeof GlobalSearchResultSchema>;
export type GlobalSearchQuery = z.infer<typeof GlobalSearchQuerySchema>;
export type GlobalSearchResponse = z.infer<typeof GlobalSearchResponseSchema>;
